import React from "react";
import PropTypes from "prop-types";

const ProgressBar = ({
	progressPercentage,
}) => {
	return (
		<div className="progress-bar-outer-container">
			<div
				className="progress-bar-inner"
				style={{
					width: progressPercentage,
				}}
			/>
		</div>
	);
};

ProgressBar.defaultProps = {
	progressPercentage: "0%",
};

ProgressBar.propTypes = {
	progressPercentage: PropTypes.string,
};

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/shared/components/ProgressBar/ProgressBar.jsx